module.exports = __webpack_public_path__ + "img/history.568003e1.png";